"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetIntegrationsByUserId = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _integrations = require("../store/integrations/integrations.selectors");

var _integrations2 = require("../store/integrations/integrations.actions");

var useGetIntegrationsByUserId = function useGetIntegrationsByUserId(id) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isPending = (0, _reactRedux.useSelector)(_integrations.getIsPending);
  var isFulfilled = (0, _reactRedux.useSelector)(_integrations.getIsFulfilled);
  var integrations = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _integrations.makeGetIntegrationsById)(id);
  }, [id]));
  (0, _react.useEffect)(function () {
    if (id) {
      dispatch((0, _integrations2.fetchIntegrationsByUserId)(id));
    }
  }, [dispatch, id]);
  return (0, _react.useMemo)(function () {
    return {
      isPending,
      isFulfilled,
      integrations
    };
  }, [integrations, isPending, isFulfilled]);
};

exports.useGetIntegrationsByUserId = useGetIntegrationsByUserId;